import styled from 'styled-components';
import { colors } from '../../../../theme/style-helpers';
import ChevronDown from '../../../../assets/icons/chevron_down_icon.svg';

export const Container = styled.div`
    display: grid;
    grid-auto-flow: row;
    row-gap: 8px;
    grid-auto-rows: max-content;
`;

export const Label = styled.label`
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    margin: 0;
`;

export const Selected = styled.div`
    padding: 12px 16px;
    height: 100%;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    margin: 0;
    color: ${({ hasPlaceholder }) => (hasPlaceholder ? '#AAAAAA' : colors.BLACK)};
`;

export const OptionsContainer = styled.div`
    display: ${({ displayMode }) => `${displayMode}`};
    position: absolute;
    left: 0;
    margin-top: 3px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 1px 1px;
    padding: 12px 0;
    background-color: ${colors.WHITE};
    width: 100%;
    max-height: 460px;
    z-index: 1;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 18px;
    }

    &::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 20px 20px #D9D9D6;
        border: solid 6px transparent;
        border-radius: 999px;
    }
`;

export const Option = styled.div`
    padding: 12px 20px;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: ${colors.BLACK};
    margin: 0;
    display: block;
    width: 100%;
    background-color: ${colors.WHITE};
    border: none;
    text-align: left;
    cursor: pointer;

    &:hover {
        background-color: #F2F2F2;
    }
`;

export const DropdownContainer = styled.button`
    background-repeat: no-repeat;
    background-position: calc(100% - 16px);
    background-image: url(${ChevronDown});
    width: 100%;
    border: 1px solid #63666A;
    border-radius: 1px;
    cursor: pointer;
    position: relative;
    background-color: ${colors.WHITE};
    padding: 0;
    text-align: left;
    min-height: 48px;

    &:focus {
        outline: auto;
        outline-color: #FFDFD0;
        outline-width: 3px;
        outline-offset: 2px;
        border-color: #D9D9D6;
    }
`;

export const Optional = styled.span`
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    margin: 0;
    color: #63666A;
`;

export const NicknameInput = styled.input`
    padding: ${({ hasIcon }) => (hasIcon ? '12px 45px 12px 16px' : '12px 16px')};
    margin: 0 12px;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    border: 1px solid ${colors.GREY_DARK};
    border-radius: 5px;
    min-width: 0;
    width: 95%;

    &:focus {
        outline-color: #FFDFD0;
        outline-width: 3px;
        outline-offset: 2px;
        border-color: ${colors.COOL_GREY};
        outline: none;
    }

    &:hover:not(:focus) {
        border-color: ${colors.BLACK};
    }

    &::placeholder {
        color: ${colors.GREY_MEDIUM};
    }

    &:disabled {
        color: ${colors.COOL_GREY};
        background-color: ${colors.GREY_100};
        border: 0px;
    }
`;

export const ClearFieldButton = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    right: 36px;
    top: 0;
    width: 24px;
    height: 48px;
    z-index: 2;

    .icon path {
        fill: ${colors.BLACK};
    }

    &:hover {
        .icon path {
            fill: ${colors.BRAND_ORANGE};
        }
    }
`;
